import Notification from '../../../js/notification';

export default new class Reviews {
  constructor() {
    this.reviewsFormSelector = 'reviews-form';
    this.reviewsSubmitSelector = 'reviews-form__submit';
    this.inValidSelector = '_invalid';
    this.duration = 3000;

    this.init();
  }

  init() {
    this.reviewsForm();
  }

  reviewsForm() {
    const form = document.querySelector(`.${this.reviewsFormSelector}`);
    const submit = document.querySelector(`.${this.reviewsSubmitSelector}`);

    submit.addEventListener('click', (e) => {
      e.preventDefault();
      this.sendForm(form);
    });
  }

  sendForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    $(form).request('ReviewForm::onSave', {
      success: (res) => {
        if (res.status === true) {
          form.reset();
        }
        const notification = new Notification();
        notification.init(res);
      },
    });
  }
}();
